import { ErrorCodes } from '@shared/models/error-codes/response.error-codes';
import { ErrorCodesService } from '@core/services/error-codes.service';

export interface Auth0OtpErrorUiState {
  inlineMessage: string;
  bannerMessage: string;
  showContactUs: boolean;
  disableContinue: boolean;
  disableResend: boolean;
  clearOtpField: boolean;
}

const CX_TEMP_RATE_LIMIT = ErrorCodes.CIAM_OTP_CX_RATE_LIMIT;
const ACCOUNT_LOCKED = ErrorCodes.CIAM_AUTH0_OTP_ACCOUNT_LOCKED;
const PER_CODE_MAX = ErrorCodes.CIAM_AUTH0_OTP_PER_CODE_MAX;

export function resolveAuth0OtpHttpError(
  err: { status?: number; error?: { code?: number; message?: string } },
  fallbackInline: string
): Auth0OtpErrorUiState {
  const code = err?.error?.code != null ? Number(err.error.code) : undefined;
  const mapped =
    code != null ? ErrorCodesService.getErrorMessage(code, err?.error?.message ?? null) : undefined;
  const message = mapped ?? err?.error?.message ?? fallbackInline;

  if (code === ACCOUNT_LOCKED) {
    return {
      inlineMessage: '',
      bannerMessage: message,
      showContactUs: true,
      disableContinue: true,
      disableResend: true,
      clearOtpField: true,
    };
  }

  if (err?.status === 429 && code === CX_TEMP_RATE_LIMIT) {
    return {
      inlineMessage: '',
      bannerMessage: message,
      showContactUs: false,
      disableContinue: false,
      disableResend: true,
      clearOtpField: false,
    };
  }

  if (code === PER_CODE_MAX) {
    return {
      inlineMessage: message,
      bannerMessage: '',
      showContactUs: false,
      disableContinue: true,
      disableResend: false,
      clearOtpField: true,
    };
  }

  return {
    inlineMessage: message,
    bannerMessage: '',
    showContactUs: false,
    disableContinue: false,
    disableResend: false,
    clearOtpField: false,
  };
}

export function applyAuth0OtpErrorUiState(
  state: Auth0OtpErrorUiState,
  host: {
    errorMessage: string;
    otpRateLimitBanner: string;
    otpContinueDisabled?: boolean;
    otpResendDisabled?: boolean;
    otpShowContactUs?: boolean;
    otpForm?: { reset: () => void };
  }
): void {
  host.errorMessage = state.inlineMessage;
  host.otpRateLimitBanner = state.bannerMessage;
  if (host.otpShowContactUs !== undefined) {
    host.otpShowContactUs = state.showContactUs;
  }
  if (host.otpContinueDisabled !== undefined) {
    host.otpContinueDisabled = state.disableContinue;
  }
  if (host.otpResendDisabled !== undefined) {
    host.otpResendDisabled = state.disableResend;
  }
  if (state.clearOtpField && host.otpForm) {
    host.otpForm.reset();
  }
}

export function resetAuth0OtpErrorUiState(host: {
  errorMessage: string;
  otpRateLimitBanner: string;
  otpContinueDisabled?: boolean;
  otpResendDisabled?: boolean;
  otpShowContactUs?: boolean;
}): void {
  host.errorMessage = '';
  host.otpRateLimitBanner = '';
  if (host.otpContinueDisabled !== undefined) {
    host.otpContinueDisabled = false;
  }
  if (host.otpResendDisabled !== undefined) {
    host.otpResendDisabled = false;
  }
  if (host.otpShowContactUs !== undefined) {
    host.otpShowContactUs = false;
  }
}
